String.prototype.capitalize = function() {
	return this.charAt(0).toUpperCase() + this.slice(1);
}

Object.filter = (obj, predicate) => 
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => (res[key] = obj[key], res), {} );


// WEBPACK FOOTER //
// ./src/helpers.js